import { defineComponent as _defineComponent } from 'vue'
import { isTouchScreen } from '@@/bits/browser'
import {
  getTailwindBgColorClass,
  getTailwindColorClass,
  SHAPE_BORDER_TO_FAKE_BORDER_COLOR_MAP,
  SHAPE_BORDER_TO_FAKE_FILL_COLOR_MAP,
} from '@@/bits/whiteboard'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import WhiteboardSvgIcon, { SVG_ICONS } from '@@/vuecomponents/WhiteboardSvgIcon.vue'
import { computed, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardSecondaryMenuIcon',
  props: {
    colorScheme: { default: 'dark' },
    iconName: { default: 'cursor' },
    selectedBackgroundColor: { default: null },
    iconColor: { default: null },
    isSelected: { type: Boolean, default: false },
    label: { default: '' },
    shortcut: { default: '' },
    xTooltip: { type: Boolean, default: false }
  },
  emits: ['hoveron', 'hoveroff', 'click'],
  setup(__props: any, { emit }) {

const props = __props as { colorScheme: 'dark' | 'light', iconName: string, selectedBackgroundColor: string | null, iconColor: string | null, isSelected: boolean, label: string, shortcut: string, xTooltip: boolean };




const isHovered = ref(false)
const isActive = ref(false)
function onPointerEnter(): void {
  isHovered.value = true
  emit('hoveron')
}
function onPointerLeave(): void {
  isHovered.value = false
  emit('hoveroff')
}

function onPointerDown(event: PointerEvent): void {
  isActive.value = true
  emit('click', event)
  // To prevent the button from staying focused after the click
  // So that when user use a keyboard shortcut to trigger another button, this button will become :focus-visible
  unfocusButton()
}
function onPointerUp(): void {
  isActive.value = false
}
function unfocusButton(): void {
  if (buttonEl.value) {
    buttonEl.value.blur()
  }
}

const buttonRef = ref<typeof OzBaseButton | null>(null)
const buttonEl = computed(() => buttonRef.value?.$el)

const isSvgIcon = computed(() => SVG_ICONS.includes(props.iconName))
const isColorIcon = computed(() => props.iconName === 'color')
const iconColor = computed((): string | null => {
  if (props.iconColor) {
    return props.iconColor
  }
  return null
})
const iconFont = computed(() => {
  if (props.iconName === 'more_vertical_thin') {
    return 'oricon'
  }
  if (props.iconName === 'link') {
    return 'oricon'
  }
  return 'wbicons'
})
const bgColorClass = computed(() => {
  if (isColorIcon.value) {
    return 'bg-transparent'
  }
  if (!props.isSelected) {
    return null
  }
  if (props.selectedBackgroundColor) {
    return getTailwindBgColorClass(props.selectedBackgroundColor)
  }
  if (props.colorScheme === 'dark') {
    if (['fill-white', 'fill-none', 'fill-solid'].includes(props.iconName) && props.iconColor === 'light-text-100') {
      return 'bg-grey-300'
    }
    return 'bg-light-ui-100'
  }

  if (props.colorScheme === 'light') {
    if (['fill-white', 'fill-none', 'fill-solid'].includes(props.iconName) && props.iconColor === 'dark-text-100') {
      return 'bg-grey-400'
    }
    return 'bg-dark-ui-100'
  }
  return null
})
const iconColorClass = computed(() => {
  if (iconColor.value != null) {
    return getTailwindColorClass(SHAPE_BORDER_TO_FAKE_BORDER_COLOR_MAP[iconColor.value] ?? iconColor.value)
  }

  if (bgColorClass.value === 'bg-dark-text-100') {
    return 'text-light-text-100'
  }
  if (bgColorClass.value === 'bg-light-text-100') {
    return 'text-dark-text-100'
  }
  return null
})

const extraClass = computed<string>(() => {
  if (
    props.colorScheme === 'dark' &&
    ['fill-white', 'fill-none', 'fill-solid'].includes(props.iconName) &&
    props.iconColor === 'dark-text-100' &&
    !props.isSelected
  ) {
    return 'ring-2 ring-grey-600 rounded-full'
  }

  if (
    props.colorScheme === 'light' &&
    ['fill-white', 'fill-none', 'fill-solid'].includes(props.iconName) &&
    props.iconColor === 'light-text-100' &&
    !props.isSelected
  ) {
    return 'ring-2 ring-grey-200 rounded-full'
  }
  return ''
})

/**
 * RESPONSIVE
 */

const isTouch = isTouchScreen()

return { __sfc: true,props, emit, isHovered, isActive, onPointerEnter, onPointerLeave, onPointerDown, onPointerUp, unfocusButton, buttonRef, buttonEl, isSvgIcon, isColorIcon, iconColor, iconFont, bgColorClass, iconColorClass, extraClass, isTouch, getTailwindColorClass, SHAPE_BORDER_TO_FAKE_FILL_COLOR_MAP, OzBaseButton, OzIcon, WhiteboardSvgIcon }
}

})